import { render, staticRenderFns } from "./MeasureLegend.vue?vue&type=template&id=7dbbd05a&scoped=true"
import script from "./MeasureLegend.vue?vue&type=script&lang=js"
export * from "./MeasureLegend.vue?vue&type=script&lang=js"
import style0 from "./MeasureLegend.vue?vue&type=style&index=0&id=7dbbd05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbbd05a",
  null
  
)

export default component.exports